<template>
  <div class="stage-switch" role="radiogroup" :aria-label="selfContent.label">
    <label v-if="selfContent.label" class="label">{{ selfContent.label }}</label>
    <div class="options">
      <button v-for="stage in stages" :key="stage.value" type="button" role="radio" class="option" :class="{selected: selfContent.value === stage.value}"
              :aria-checked="selfContent.value === stage.value" :title="stage.help" @click="choose(stage.value)">{{ stage.label }}</button>
    </div>
    <p class="help">{{ help }}</p>
  </div>
</template>

<script>
import {FUNNEL_STAGE_ENUM} from "@/marketing/utils";

/**
 * Choix de l'intention d'un contenu : un interrupteur à trois positions, sans note ni pondération.
 * content : {label, value (TOFU, MOFU ou BOFU), readOnly}
 */
export default {
  name: 'FunnelStageSwitch',
  props: ['content'],
  data() {
    return {
      selfContent: this.content,
      stages: Object.values(FUNNEL_STAGE_ENUM),
    };
  },
  computed: {
    help() {
      const stage = FUNNEL_STAGE_ENUM[this.selfContent.value];
      return stage ? stage.help : "Que doit faire ce contenu pour votre activité ?";
    },
  },
  methods: {
    choose(value) {
      if (this.selfContent.readOnly) return;
      this.selfContent.value = value;
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.label
  display block
  margin 8px 0 4px 2px
  color CTRL_TEXT_MUTED
  font-size 0.82em
  font-weight 600

.options
  display grid
  grid-template-columns repeat(3, 1fr)
  gap 0
  border 1px solid CTRL_BORDER
  border-radius CTRL_RADIUS
  overflow hidden
  background CTRL_BG

// La position choisie est en bleu
.option
  box-sizing border-box
  height CTRL_HEIGHT
  padding 0 8px
  border none
  border-right 1px solid CTRL_BORDER
  background transparent
  color FONT_COLOR
  font-family inherit
  font-size 14px
  font-weight 600
  cursor pointer
  transition background-color CTRL_EASE, color CTRL_EASE

  &:last-child
    border-right none

  &:hover
    background CTRL_BG_HOVER

  &.selected
    background THEME_COLOR_PRIMARY
    color THEME_COLOR_PRIMARY_OPPOSITE

.help
  margin 6px 2px 0
  min-height 2.6em
  font-size 0.85em
  color CTRL_TEXT_MUTED
</style>
